import React from 'react';

const TipsEarnedIcon = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    aria-hidden="true"
  >
    <circle cx="20" cy="20" r="20" fill="#34C759" />
    <path
      d="M15 25L25 15M25 15H17M25 15V23"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TipsEarnedIcon;
